// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function AlertTitle() {
  return {
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          fontWeight: 800,
          marginBottom: 4,
          marginTop: 0,
        }
      }
    }
  };
}
